/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Task_Email_Assignee_UnavailableInputs */

const en_api_error_task_email_assignee_unavailable = /** @type {(inputs: Api_Error_Task_Email_Assignee_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The assignee is disabled or has no email.`)
};

const pt_br2_api_error_task_email_assignee_unavailable = /** @type {(inputs: Api_Error_Task_Email_Assignee_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O responsável está inativo ou não tem e-mail.`)
};

/**
* | output |
* | --- |
* | "The assignee is disabled or has no email." |
*
* @param {Api_Error_Task_Email_Assignee_UnavailableInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_task_email_assignee_unavailable = /** @type {((inputs?: Api_Error_Task_Email_Assignee_UnavailableInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Task_Email_Assignee_UnavailableInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_task_email_assignee_unavailable(inputs)
	return pt_br2_api_error_task_email_assignee_unavailable(inputs)
});